import { makeStyles, css } from '@conexasaude/conexa-hero'
import noise from '@/assets/noise.png'
import { IS_PRODUCTION } from '@/constants'

const useStyles = makeStyles<{ bodySize: string }>({
  layoutContainer: theme => css`
    display: flex;
    flex-direction: row;
    position: relative;
    height: ${IS_PRODUCTION ? '100vh ' : `calc(100vh - 32px)`};
    width: 100%;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      flex-direction: column;
    }
  `,

  containerBackground: theme => css`
    position: relative;
    width: 55%;
    height: ${IS_PRODUCTION ? '100vh ' : `calc(100vh - 32px)`};
    display: flex;
    background: ${theme.colors.brand.primary[500]};
    background-size: 400% 400%;
  `,

  backgroundContentContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
  `,

  logoWhiteLabel: css`
    width: 150px;
  `,

  logoWrapper: theme => css`
    padding-left: ${theme.spacing.sm};
    margin-bottom: ${theme.spacing.sm};
    padding-top: ${theme.spacing.xxs};
  `,

  contentContainer: theme => css`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      flex-direction: column;
    }
  `,

  content: theme => css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing.xxs};
  `,

  backgroundNoise: css`
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(${noise});
      background-position: center;
      background-size: 100% 400%;
      background-repeat: repeat;
      opacity: 0.5;
    }
  `,

  backgroundContainerTitle: theme => css`
    text-align: center;
    padding: 0 ${theme.spacing.md};
    margin-bottom: ${theme.spacing.xxs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
    }
  `,

  backgroundContainerSubtitle: theme => css`
    text-align: center;
    padding: 0 ${theme.spacing.md};
    margin-top: ${theme.spacing.xs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
      padding: ${theme.spacing.xs} ${theme.spacing.xl};
    }
  `,

  backgroundContainerIcon: theme => css`
    padding: ${theme.spacing.xxs};
    z-index: 1;
    width: 80%;
    max-width: 398px;
    height: 398px;
    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      max-width: 320px;
      width: 100%;
    }
  `,

  contentWrapper: (theme, { bodySize }) => css`
    display: flex;
    align-self: center;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    max-width: ${bodySize || '460px'};
    overflow-y: auto;
  `,

  body: ({ spacing, grid }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    overflow-y: auto;
    gap: ${spacing.xxs};
    padding: ${spacing.xxs} ${spacing.lg};
    flex: 1;
    @media (max-width: ${grid.breakpoint.lg}) {
      padding: ${spacing.sm} ${spacing.md} ${spacing.xxs} ${spacing.md};
    }

    @media (max-width: ${grid.breakpoint.md}) {
      padding: ${spacing.sm} ${spacing.sm} ${spacing.xxs} ${spacing.sm};
    }

    @media (max-width: ${grid.breakpoint.sm}) {
      padding: 0 ${spacing.xs} ${spacing.xs} ${spacing.xs};
    }
  `,

  stepperArea: theme => css`
    flex-shrink: 0;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin-right: 0;
      margin-bottom: ${theme.spacing.sm};
      align-self: flex-start;
    }
  `,
  mobileStepperArea: theme => css`
    margin-bottom: ${theme.spacing.sm};
  `,

  childrenContainer: css`
    flex-grow: 1;
  `,

  contentHeader: css`
    display: flex;
    align-self: center;
    flex-direction: column;
    flex-shrink: 0;
    width: 100%;
    max-width: 360px;
  `,

  buttonWrapper: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    flex-grow: 1;
    width: 100%;
    margin-top: ${theme.spacing.xxs};
  `,

  titleContainer: theme => css`
    flex-grow: 1;
    h2 {
      font-weight: ${theme.fontWeights.extraBold};
      line-height: ${theme.spacing.md};
      font-family: ${theme.typography.label.fontFamily};
      font-size: ${theme.fontSizes['2xl']};

      span {
        color: ${theme.colors.brand.primary[300]};
        font-family: ${theme.typography.label.fontFamily};
      }
    }
  `,

  mainCard: css`
    display: flex;
    width: 100%;
    flex-grow: 1;
  `,

  subtitleWrapper: theme => css`
    margin: ${theme.spacing.xxs} 0;
    color: ${theme.colors.neutral[300]};
    font-family: ${theme.typography.label.fontFamily};
    font-size: ${theme.fontSizes.sm};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: ${theme.spacing.xxs} 0 ${theme.spacing.xs} 0;
    }
  `,

  flexContainer: theme => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.spacing.xxs};
  `,
})

export { useStyles }
